import serviceS3 from "@/services/serviceRelatorio";
import { toast } from "react-toastify";

//bucketName: Nome do Bucket no S3
//keyName: Nome do arquivo no Bucket
//localDest: Nome para salvar o arquivo baixado (opcional, por padrão usará o 'keyName')
export async function s3download(bucketName: string, keyName: string, localDest: string = "") {
    if (localDest === "") {
        localDest = keyName;
    }

    let params = {
        bucketName: bucketName,
        fileName: keyName,
    };

    serviceS3
        .download(params)
        .then((result) => {
           
           if(result){
                const linkSource = `data:application/${keyName.substring(keyName.length - 3)};base64,${result.data}`;
                const downloadLink = document.createElement("a");
            
                downloadLink.href = linkSource;
                downloadLink.download = keyName;
                downloadLink.click();
           }
        });
}

//bucketName: Nome do Bucket no S3
//keyName: Nome do arquivo a ser salvo no Bucket
//fileBase64: Conteúdo do arquivo em string base64
//showSucessMessage: exibir toast para sucesso no upload
export async function s3upload(bucketName: string, keyName: string, fileBase64: string, showSucessMessage: boolean = false) {

    let params = {
        fileBase64: fileBase64,
        bucketName: bucketName,
        fileName: keyName,
    };

    serviceS3
        .upload(params)
        .then((result) => {         
           if(result){
                if (showSucessMessage) {
                    toast.success("Upload realizado com sucesso");
                }
           }
        });
}
